<template>
  <div class="white mt-12 pt-5">
    <v-row class="wrap pt-0 px-12 d-none d-md-block grey lighten-4" no-gutters align-center>
      <v-col cols="12" md="12" class="pa-1">
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-skeleton-loader
          type="table-row"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    
  </div>
</template>


<script>
import {firebase, db, auth, store} from '@/fb';
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import axios from 'axios';
import { format, render, cancel, register } from 'timeago.js';
const api = `https://us-central1-shipping-master.cloudfunctions.net/main`
const headers = {'Accept': 'application/json'}
const loadedLeads = []

export default {
  // components: {
  //   VueFeedbackReaction,
  //   VueReactionEmoji
  // },
  data() {
    return {
      loading:true,
      
    }
  },
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
    
  },
  props:{
    
  },
  async created(){

  },
  computed:{
    
  },
  watch: {

  },
  mounted(){
    
  }
}
</script>

<style>
.homeCards .v-card {
  border-radius: 10px !important;
}
.homeCardTitle {
  font-size: 1.1rem !important;
  font-weight: bold !important;
  line-height: 1.1 !important;
}
</style>